import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core'
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from '@angular/forms'
import { SettingsService } from '@dot-it/jml-lib'
import StringUtils from '../../../../../../utils/string.utils'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Component({
  selector: 'jml-lib-currency-control',
  templateUrl: './currency-control.component.html',
  styleUrls: ['./currency-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyControlComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: CurrencyControlComponent,
      multi: true
    }
  ]
})
export class CurrencyControlComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder: string = ''
  @Input() float: boolean = false
  @Input() control: FormControl
  @Input() autoSelect = false

  @Output() blur: EventEmitter<Event> = new EventEmitter()
  @Output() focus: EventEmitter<Event> = new EventEmitter()

  currency$: Observable<string>
  onChange = (obj) => {}
  onTouched = (obj) => {}
  onBlur = (event) => this.blur.emit(event)
  onFocus = () => this.focus.emit()

  constructor(private settingsService: SettingsService) {}

  ngOnInit(): void {
    // get Currency from settings
    this.currency$ = this.settingsService.getSetting('CURRENCY').pipe(map((setting) => setting.value))

    if (!this.control) {
      this.control = new FormControl('')
    }

    this.control.setValidators([Validators.pattern(/^-?\d{1,3}((\.)?\d{3})*(,\d{1,2})?$/)])

    this.control.valueChanges.subscribe((value) => this.onChange(StringUtils.currencyStringToLong(value)))
  }

  writeValue(obj: any): void {
    // TODO in inline cell value comes as long, in edit Dialog it comes as {currency, uom}
    const value = !!obj && typeof obj === 'object' ? obj.currency : obj
    this.control.patchValue(StringUtils.currencyRepresentation(value))
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable()
    } else {
      this.control.enable()
    }
  }

  validate({ value }: FormControl) {
    return this.control.invalid && { invalid: true }
  }
}
